import { useAuth } from '../context/AuthContext';

export default useAuth;